/*
 * Copyright (c) 2026 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

/**
 * Where the theme preference is persisted, so the next boot can replay it before first paint and a
 * dark-mode user doesn't watch the splash open light and snap dark once their settings land.
 *
 * Three places know this key: the inline script in `index.html` (which applies it pre-paint), the
 * kit's `ThemeProvider` (which reads and writes it, via `storageKey` in `app/providers.tsx`), and
 * this constant. Rename it in all three or not at all.
 *
 * The stored value is the *preference*, so it can be `system` as well as `light` or `dark`. The
 * inline script only recognises the latter two and otherwise falls through to the OS preference,
 * which is what `system` means anyway.
 */
export const THEME_CACHE_KEY = 'ediag.theme';
